import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const onerepmaxfitnessApiService = createApi({
  reducerPath: "onerepmaxfitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createORM: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `onerepmaxfitness/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getORM: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `onerepmaxfitness/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateORM: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `onerepmaxfitness/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
  }),
});

export const { useCreateORMMutation, useGetORMQuery, useUpdateORMMutation } =
  onerepmaxfitnessApiService;
